<template>
    <div class="property-manage">
        <!-- 统计卡片 -->
        <div class="stats-row">
            <div class="stat-card stat-total">
                <div class="stat-icon-wrap">
                    <i class="el-icon-document"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.totalCount }}</div>
                    <div class="stat-desc">提交总数</div>
                </div>
            </div>
            <div class="stat-card stat-issued">
                <div class="stat-icon-wrap">
                    <i class="el-icon-medal"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.approvalCount }}</div>
                    <div class="stat-desc">已颁发证书</div>
                </div>
            </div>
            <div class="stat-card stat-pending">
                <div class="stat-icon-wrap">
                    <i class="el-icon-time"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.underApprovalCount }}</div>
                    <div class="stat-desc">审核中</div>
                </div>
            </div>
        </div>

        <!-- 查询区域 -->
        <el-card class="search-card" shadow="never">
            <el-form :inline="true" :model="queryForm">
                <el-form-item label="登记编号">
                    <el-input v-model="queryForm.registrationId" placeholder="请输入登记编号" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="企业名称">
                    <el-input v-model="queryForm.companyName" placeholder="请输入企业名称" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="数据资产名称">
                    <el-input v-model="queryForm.assetName" placeholder="请输入资产名称" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="证书状态">
                    <el-select v-model="queryForm.status" placeholder="证书状态" style="width: 140px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="已颁发证书" value="已颁发证书"></el-option>
                        <el-option label="未颁发证书" value="未颁发证书"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 数据表格 -->
        <el-card class="table-card" shadow="never"
            v-loading="loading"
            element-loading-text="证书生成中，请稍候..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.7)">
            <el-table :data="tableData" border style="width: 100%"
                :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="registrationId" label="资产登记编号" min-width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetName" label="数据资产名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="companyName" label="企业名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" min-width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusTagType(scope.row.authState)" size="small" effect="light">
                            {{ formatStatus(scope.row.authState) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="有效期至" min-width="190" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.effectiveDate || '--' }}</span>
                        <el-tag v-if="isExpired(scope.row.effectiveDate)" type="danger" size="mini"
                            style="margin-left: 6px; vertical-align: middle;">已过期</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="reviewTime" label="发证时间" min-width="170" align="center"></el-table-column>
                <el-table-column prop="operator" label="操作人" min-width="100" align="center"></el-table-column>
                <el-table-column label="操作" min-width="240" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary"
                            v-if="formatStatus(scope.row.authState) === '审核公示中' || formatStatus(scope.row.authState) === '已颁发证书'"
                            @click="handleIssue(scope.row)">
                            {{ formatStatus(scope.row.authState) === '审核公示中' ? '颁发证书' : '重新颁发证书' }}
                        </el-button>
                        <el-button size="mini" type="danger"
                            v-if="isExpired(scope.row.effectiveDate)"
                            @click="handleExpire(scope.row)">
                            设为已过期
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                    layout="total, sizes, prev, pager, next"
                    :total="boardsTotal"
                    :page-size="pageSize"
                    :current-page="currPage"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PropertyManage",
    components: { AddBoardContent },
    data() {
        return {
            boardsTotal: 0,
            currPage: 1,
            pageSize: 10,
            queryForm: {
                registrationId: '',
                companyName: '',
                assetName: '',
                type: '全部',
                status: '全部'
            },
            countData: {
                totalCount: 0,
                approvalCount: 0,
                underApprovalCount: 0
            },
            tableData: [],
            currentName: '',
            loading: false
        }
    },
    mounted() {
        this.fetchCountData();
        this.initTableData();
    },
    methods: {
        fetchCountData() {
            this.getRequest('/web/dataAssets/queryCount').then(resp => {
                if (resp && resp.data) {
                    this.countData = resp.data;
                }
            });
        },
        initTableData() {
            this.getRequest('/web/dataAssets/review/getList?registrationId=' + this.queryForm.registrationId
                + '&companyName=' + this.queryForm.companyName
                + '&assetName=' + this.queryForm.assetName
                + '&registrationType=' + (this.queryForm.type === '全部' ? '' : this.queryForm.type)
                + '&state=' + (this.queryForm.status === '全部' ? '' : this.queryForm.status)
                + '&currPage=' + this.currPage + '&pageSize=' + this.pageSize).then(resp => {
                    if (resp && resp.data) {
                        this.boardsTotal = resp.data.total;
                        this.tableData = resp.data.list;
                    }
                });
        },
        doSearch() {
            this.currPage = 1;
            this.initTableData();
        },
        resetSearch() {
            this.queryForm = { registrationId: '', companyName: '', assetName: '', type: '全部', status: '全部' };
            this.currPage = 1;
            this.initTableData();
        },
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currPage = 1;
            this.initTableData();
        },
        formatStatus(status) {
            const statusMap = {
                '0': '待审核', '1': '初审通过', '2': '复审通过', '3': '终审通过',
                '4': '初审驳回', '5': '复审驳回', '6': '终审驳回'
            };
            return statusMap[status] || status;
        },
        getStatusTagType(status) {
            const s = this.formatStatus(status);
            if (s === '已颁发证书') return 'success';
            if (s.includes('驳回')) return 'danger';
            if (s === '待审核') return 'info';
            if (s === '审核公示中') return 'warning';
            return '';
        },
        isExpired(effectiveDate) {
            if (!effectiveDate) return false;
            const match = effectiveDate.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
            if (!match) return false;
            const date = new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]));
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < today;
        },
        handleIssue(row) {
            const action = this.formatStatus(row.authState) === '已颁发证书' ? '重新颁发证书' : '颁发证书';
            this.$confirm(`确定要${action}该数据资产吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.axios.get('/web/certificate/create', {
                    params: { registrationId: row.registrationId }
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success(`${action}成功`);
                        this.initTableData();
                        this.fetchCountData();
                    } else {
                        this.$message.error(`${action}失败`);
                    }
                }).catch(error => {
                    this.$message.error(`${action}失败: ${error.message}`);
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        },
        handleExpire(row) {
            this.$confirm(`确定要将「${row.assetName}」证书设为已过期吗？此操作不可撤销。`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.axios.get('/web/certificate/expired', {
                    params: { registrationId: row.registrationId }
                }).then(resp => {
                    if (resp && resp.data && resp.data.status === 200) {
                        this.$message.success('已成功设为过期');
                        this.initTableData();
                        this.fetchCountData();
                    } else {
                        this.$message.error('操作失败');
                    }
                }).catch(error => {
                    this.$message.error('操作失败: ' + error.message);
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        }
    }
}
</script>

<style scoped>
.property-manage {
    padding: 20px 24px;
    background: #f0f2f5;
    min-height: 100%;
}

/* 统计卡片 */
.stats-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
}

.stat-card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    background: #fff;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border-left: 4px solid transparent;
    transition: box-shadow 0.2s;
}

.stat-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-total  { border-left-color: #409EFF; }
.stat-issued { border-left-color: #67C23A; }
.stat-pending { border-left-color: #E6A23C; }

.stat-icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
}

.stat-total  .stat-icon-wrap { background: #ecf5ff; color: #409EFF; }
.stat-issued .stat-icon-wrap { background: #f0f9eb; color: #67C23A; }
.stat-pending .stat-icon-wrap { background: #fdf6ec; color: #E6A23C; }

.stat-number {
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
}

.stat-total  .stat-number { color: #409EFF; }
.stat-issued .stat-number { color: #67C23A; }
.stat-pending .stat-number { color: #E6A23C; }

.stat-desc {
    font-size: 13px;
    color: #909399;
}

/* 查询区域 */
.search-card {
    margin-bottom: 16px;
    border-radius: 10px;
    border: none;
}

.search-card >>> .el-card__body {
    padding: 16px 20px 4px;
}

.search-card >>> .el-form-item {
    margin-bottom: 12px;
    margin-right: 16px;
}

/* 表格区域 */
.table-card {
    border-radius: 10px;
    border: none;
}

.table-card >>> .el-card__body {
    padding: 16px 20px;
}

.table-card >>> .el-table th {
    font-weight: 600;
}

.table-card >>> .el-table td {
    padding: 10px 0;
}

/* 分页 */
.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>
